/* eslint-disable react/jsx-indent, camelcase, no-undef, no-empty */
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector, useDispatch } from 'react-redux';
import { chatLoad } from 'stores/settings/settingsActions';

export const isTawktoLoaded = () => {
  return typeof Tawk_API !== 'undefined';
};

export const getTawktoApi = () => {
  return Tawk_API;
};

const TawktoChat = ({
  checkHasFeature = true,
  visible = true,
  user,
  onLoad
}) => {
  const dispatch = useDispatch();
  const { chatLoaded = false } = useSelector((state) => state.settings);

  const configureChatLoad = () => {
    try {
      if (window.Tawk_API && !chatLoaded) {
        if (window.Tawk_API.onLoaded) {
          if (onLoad) {
            onLoad();
          }
          dispatch(chatLoad());
        } else {
          setTimeout(() => configureChatLoad(), 1000);
        }
      } else if (
        !window.limitRetryChatLoad ||
        window.limitRetryChatLoad <= 15
      ) {
        setTimeout(() => configureChatLoad(), 1000);
      }
      window.limitRetryChatLoad += 1;
    } catch (error) {}
  };

  useEffect(() => {
    window.limitRetryChatLoad = 1;
    configureChatLoad();
  }, []);

  useEffect(() => {
    try {
      if (chatLoaded && user) {
        window.Tawk_API.setAttributes({
          name: user.name,
          email: user.email
        });
      }
    } catch (error) {}
  }, [chatLoaded]);

  useEffect(() => {
    if (isTawktoLoaded()) {
      if (visible) {
        Tawk_API.showWidget();
      } else {
        Tawk_API.hideWidget();
      }
    }
    return () => {
      if (Tawk_API && typeof Tawk_API.minimize === 'function') {
        Tawk_API.minimize();
        Tawk_API.hideWidget();
      }
    };
  }, [visible]);

  return (
    !isTawktoLoaded() &&
    (!checkHasFeature ? (
      <Helmet>
        <script type="text/javascript">
          {`
        var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
        (function(){
        var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
        s1.async=true;
        s1.src='https://embed.tawk.to/629932897b967b117992a153/1g4j6qqib';
        s1.charset='UTF-8';
        s1.setAttribute('crossorigin','*');
        s0.parentNode.insertBefore(s1,s0);
       
        Tawk_API.onLoad = function() {              
          if (${visible}) {
            Tawk_API.showWidget();
          } else {
            Tawk_API.hideWidget();
          };          
        };
      })();
    `}
        </script>
      </Helmet>
    ) : null)
  );
};

export default TawktoChat;
